

import { SidebarHeader } from './sidebar/SidebarHeader';
import { SidebarNavigation } from './sidebar/SidebarNavigation';
import { SidebarUserFooter } from './sidebar/SidebarUserFooter';

export function AppSidebar() {
  return (
    <div className="fixed left-0 top-0 z-50 flex h-screen w-64 flex-col bg-white border-r border-gray-200">
      <SidebarHeader />
      <SidebarNavigation />
      <SidebarUserFooter />
    </div>
  );
}
